import { createTheme } from '@mui/material/styles';
var theme = createTheme({
    palette: {
        primary: { main: '#2196f3', light: '#64b5f6', dark: '#1976d2' },
        secondary: { main: '#ff9800', light: '#ffb74d', dark: '#f57c00' },
        background: { default: '#f5f5f5', paper: '#ffffff' },
        success: { main: '#4caf50', light: '#81c784', dark: '#388e3c' },
        error: { main: '#f44336', light: '#e57373', dark: '#d32f2f' },
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        h1: { fontSize: '2.5rem', fontWeight: 500 },
        h2: { fontSize: '2rem', fontWeight: 500 },
        h3: { fontSize: '1.75rem', fontWeight: 500 },
        h4: { fontSize: '1.5rem', fontWeight: 500 },
        h5: { fontSize: '1.25rem', fontWeight: 500 },
        h6: { fontSize: '1rem', fontWeight: 500 },
    },
    components: {
        MuiButton: {
            styleOverrides: { root: { textTransform: 'none', borderRadius: 8 } },
        },
        MuiCard: {
            styleOverrides: { root: { borderRadius: 12, boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' } },
        },
        MuiTextField: {
            styleOverrides: { root: { '& .MuiOutlinedInput-root': { borderRadius: 8 } } },
        },
    },
});
export default theme;
